<template>
  <div class="head-page">
    <Header :title="$t('transfer.title')" />
    <van-tabs v-model="active" @change="changeTab">
      <van-tab :title="item.txt" :name="item.val" v-for="(item, index) in tabs" :key="index" />
    </van-tabs>
    <div class="trade-lst-databox" v-if="list.length > 0">
      <van-pull-refresh
        :pulling-text="$t('common.pulling')"
        :loosing-text="$t('common.loosing')"
        :loading-text="$t('common.loading')"
        v-model="refreshing"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('common.nomore')"
          :loading-text="$t('common.loading')"
          :error-text="$t('common.errortxt')"
          @load="onLoad"
        >
          <div v-for="(item, index) in list" :key="index">
            <div style="margin: 10px 0px 0px 0px">
              <LstItem :item="item" @reset-lst="onRefresh" />
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div v-else class="trade-lst-databox">
      <van-empty :description="$t('common.nodata')" />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import LstItem from './components/item.vue'
export default {
  name: "MemberTransferList",
  components: { Header, LstItem },
  data() {
    return {
      tabs: [
        {val: 0, txt: this.$t('common.all')},
        {val: 1, txt: this.$t('transfer.transfering')},
        {val: 2, txt: this.$t('common.finished')},
        {val: 3, txt: this.$t('common.canceled')},
      ],
      active: null,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      limit: 10,
      page: 1,
    };
  },
  methods: {
    onLoad() {
      this.getData();
    },
    async getData() {
      await this.$http({
        method: "post",
        url: "getInternalTransferList",
        data: {
          status: this.active,
          limit: this.limit,
          page: this.page,
        },
      }).then((res) => {
        this.refreshing = false;
        this.loading = false;
        if (res && res.data && res.data.list) {
          res.data.list.forEach((element) => {
            this.list.push(element);
          });
          if (res.data.list.length < this.limit) {
            this.finished = true;
          } else {
            this.page += 1;
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },
    onRefresh() {
      this.page = 1;
      this.list = [];
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    changeTab(){
      this.onRefresh()
    }
  },
};
</script>

<style>
</style>
